import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaWhatsapp, FaTimes } from "react-icons/fa";
import "react-phone-input-2/lib/style.css";

const inputStyle = {
  width: "100%",
  padding: "10px 12px",
  marginBottom: "6px",
  borderRadius: "10px",
  border: "1px solid #ddd",
  fontSize: "14px"
};

const errorStyle = {
  color: "red",
  fontSize: "12px",
  marginBottom: "8px"
};

const submitStyle = {
  width: "100%",
  padding: "12px",
  borderRadius: "30px",
  border: "none",
  background: "#25D366",
  color: "#fff",
  fontWeight: "bold",
  cursor: "pointer",
  marginTop: "12px"
};

function QueryForm({ open, setOpen }) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    countryCode: "+91",
    phone: "",
    budget: "",
    platform: [],
    location: "",
    timeToCall: "",
    message: ""
  });

  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState("");

  const toggle = () => setOpen(prev => !prev);

  const handleChange = e => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox" && name === "platform") {
      setFormData(prev => {
        const platforms = checked
          ? [...prev.platform, value]
          : prev.platform.filter(p => p !== value);
        return { ...prev, platform: platforms };
      });
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const validate = () => {
    let err = {};

    if (!formData.name || formData.name.length < 3)
      err.name = "Name must be at least 3 characters";

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email))
      err.email = "Invalid email format";

    const phoneOnly = (formData.phone || "").replace(/\D/g, "");
    if (phoneOnly.length < 10)
      err.phone = "Phone must be valid";

    return err;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const validationErrors = validate();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) return;

    const fullPhone = formData.countryCode + formData.phone;

    const message = `Hello, I want to contact you:

Name: ${formData.name}
Email: ${formData.email}
Phone: ${fullPhone}
Budget: ${formData.budget}
Platform: ${formData.platform.join(", ")}
Location: ${formData.location}
Time to Call: ${formData.timeToCall}
Message: ${formData.message}`;

    const encodedMessage = encodeURIComponent(message);

    window.open(
      `https://wa.me/917976708564?text=${encodedMessage}`,
      "_blank"
    );

    setStatus("Redirecting to WhatsApp...");
    setTimeout(() => setStatus(""), 3000);
  };

  return (
    <div style={{ position: "fixed", right: 20, bottom: 20, zIndex: 3000 }}>
      <AnimatePresence>
        {open && (
          <motion.div
            style={{
              background: "#fff",
              padding: 20,
              borderRadius: 20,
              width: 340,
              boxShadow: "0 25px 60px rgba(0,0,0,0.2)",
              marginBottom: 15
            }}
          >
            <h3 style={{ textAlign: "center", color: "#25D366" }}>
              Contact on WhatsApp
            </h3>

            <form onSubmit={handleSubmit}>
              <input name="name" placeholder="Name" onChange={handleChange} style={inputStyle} />
              {errors.name && <div style={errorStyle}>{errors.name}</div>}

              <input name="email" placeholder="Email" onChange={handleChange} style={inputStyle} />
              {errors.email && <div style={errorStyle}>{errors.email}</div>}

              <input name="phone" placeholder="Phone" onChange={handleChange} style={inputStyle} />
              {errors.phone && <div style={errorStyle}>{errors.phone}</div>}

              <input name="budget" placeholder="Budget" onChange={handleChange} style={inputStyle} />
              <div style={{ marginBottom: "10px" }}>
  <label style={{ fontWeight: "bold" }}>Platform:</label>

  <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
    <label>
      <input type="checkbox" name="platform" value="iOS" onChange={handleChange} /> iOS
    </label>

    <label>
      <input type="checkbox" name="platform" value="Android" onChange={handleChange} /> Android
    </label>

    <label>
      <input type="checkbox" name="platform" value="WebApp" onChange={handleChange} /> WebApp
    </label>

    <label>
      <input type="checkbox" name="platform" value="AI Chatbot" onChange={handleChange} /> AI Chatbot
    </label>
  </div>
</div>
              <input name="location" placeholder="Location" onChange={handleChange} style={inputStyle} />
              <input name="timeToCall" placeholder="Time to Call" onChange={handleChange} style={inputStyle} />
              <textarea name="message" placeholder="Message" onChange={handleChange} style={inputStyle} />

              <button type="submit" style={submitStyle}>
                <FaWhatsapp /> Chat on WhatsApp
              </button>
            </form>

            {status && <div style={{ textAlign: "center", marginTop: 10 }}>{status}</div>}
          </motion.div>
        )}
      </AnimatePresence>

      {/* 🔥 ICON FIXED HERE */}
      <motion.button
        onClick={toggle}
        style={{
          width: 65,
          height: 65,
          borderRadius: "50%",
          background: "#25D366",
          color: "#fff",
          fontSize: 26,
          border: "none",
          cursor: "pointer"
        }}
      >
        {open ? <FaTimes /> : <FaWhatsapp />}
      </motion.button>
    </div>
  );
}

export default QueryForm;